module.exports = __webpack_public_path__ + "img/allthebridge4.f0c6ba25.jpg";